import { AutogenModelEdiCbpHts, AutogenRowEdiCbpHts } from "./autogen/AutogenModelEdiCbpHts";

export class ModelEdiCbpHts extends AutogenModelEdiCbpHts<RowEdiCbpHts> {
	constructor() {
		super(RowEdiCbpHts);
	}
}

export class RowEdiCbpHts extends AutogenRowEdiCbpHts {
}